//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import website from '@/config/website';
export default {
  name: "thirdLogin",
  methods: {
    handleClick: function handleClick(source) {
      window.location.href = "".concat(website.authUrl, "/").concat(source);
    }
  }
};